import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "home-columns" }
const _hoisted_3 = {
  key: 0,
  class: "text-body-2 text-grey"
}
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = {
  key: 0,
  class: "text-body-2 text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_workspace_row = _resolveComponent("ontos-workspace-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_recent_row = _resolveComponent("ontos-recent-row")!
  const _component_ontos_section = _resolveComponent("ontos-section")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, {
              title: _ctx.$tt('workspaces')
            }, {
              controls: _withCtx(() => [
                _createVNode(_component_ontos_header_action, {
                  icon: "mdi-plus",
                  color: "primary",
                  label: _ctx.$tt('workspace-create'),
                  to: {name: 'create-system'}
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("section", null, [
                (!_ctx.systems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$tt('workspaces-empty')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openSystems, (system) => {
                  return (_openBlock(), _createBlock(_component_ontos_workspace_row, {
                    key: system.alias,
                    system: system,
                    overview: _ctx.overviewOf(system)
                  }, null, 8, ["system", "overview"]))
                }), 128)),
                (_ctx.closedSystems.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "closed-toggle text-body-2 text-medium-emphasis",
                        "aria-expanded": _ctx.showClosed,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleClosed()))
                      }, [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showClosed ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$tt('closed-workspaces', {count: _ctx.closedSystems.length})), 1)
                      ], 8, _hoisted_4),
                      (_ctx.showClosed)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.closedSystems, (system) => {
                            return (_openBlock(), _createBlock(_component_ontos_workspace_row, {
                              key: system.alias,
                              system: system,
                              overview: _ctx.overviewOf(system)
                            }, null, 8, ["system", "overview"]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.overviews)
                ? (_openBlock(), _createBlock(_component_ontos_section, {
                    key: 0,
                    class: "ontos-arrives",
                    title: _ctx.$tt('recent-activity'),
                    divider: false,
                    level: 2,
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.recent.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$tt('recent-activity-empty')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recent, (entry) => {
                        return (_openBlock(), _createBlock(_component_ontos_recent_row, {
                          key: `${entry.system.alias}.${entry.item.idea}.${entry.item._instance}`,
                          item: entry.item,
                          place: `${entry.system.title} › ${entry.item.ideaName || entry.item.idea}`,
                          to: {name: 'view-instance',
                                  params: {system: entry.system.alias, idea: entry.item.idea, instance: entry.item._instance}}
                        }, null, 8, ["item", "place", "to"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}